function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fcd022"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5h7.5v20H0V5Z",
    style: {
      fill: "#002674"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,5h7.5v20h-7.5V5ZM12.75,11.495l1.875,3.247-1.875,3.248-1.875-3.248,1.875-3.247ZM17.25,11.495l1.875,3.247-1.875,3.248-1.875-3.248,1.875-3.247ZM15,15.392l1.875,3.248-1.875,3.248-1.875-3.248,1.875-3.248Z",
    style: {
      fill: "#007c2e"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVc);
export default __webpack_public_path__ + "static/media/VC.8557040edcbcce919b2d8b38dfd30f16.svg";
export { ForwardRef as ReactComponent };